import { CourseOfferingRecommendationTemplate } from 'app/library/course-offering-recommendation/models/course-offering-recommendation-template.model';
import { IRecommendationSectionQuery } from '../interfaces/recommendation-section.query.interface';

// @dynamic
export class RecommendationSection {
    id: string;
    syncWithOffering: boolean;
    template: CourseOfferingRecommendationTemplate | null;

    constructor(query: IRecommendationSectionQuery) {
        this.id = query.id.toString();
        this.syncWithOffering = query.sync_with_offering;
        this.template = query.template ? new CourseOfferingRecommendationTemplate(query.template) : null;
    }
}
